var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.95 12.32C19.86 6.9 16.42 2.04 11.02 2h-.04c-5.4.04-8.84 4.9-8.93 10.32-.03.2-.05.41-.05.63 0 .78.18 1.41.55 1.87.37.47.9.73 1.54.77a9.28 9.28 0 0 0 2.73 2.99c1.3.9 2.74 1.4 4.16 1.42h.04a7.56 7.56 0 0 0 4.16-1.42 9.26 9.26 0 0 0 2.73-3c.65-.03 1.17-.3 1.54-.76.36-.46.55-1.09.55-1.87 0-.22-.02-.43-.05-.63zm-2.21 2.22a.8.8 0 0 1-.07 0l-.38-.03-.16.31c-1 1.96-3.35 4.07-6.13 4.13-2.78-.06-5.12-2.17-6.14-4.13l-.15-.31-.38.03a.8.8 0 0 1-.07 0c-.8 0-1.21-.53-1.21-1.59 0-.35.12-1.66.99-1.78.71-.1 1.07.02 1.54.6.06.08.16.14.28.14.14 0 .27-.1.32-.22v-.03l.01-.02c.23-1.06.3-2.5 1.03-2.74.68-.22 2.14.02 3.76.04h.04c1.62-.02 3.07-.26 3.76-.04.73.24.8 1.68 1.03 2.74v.04l.01.01c.05.13.18.22.32.22.11 0 .22-.06.28-.15.47-.57.83-.69 1.54-.59.87.12.99 1.43.99 1.78 0 1.06-.4 1.6-1.21 1.6zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMale);
export default ForwardRef;